import { NoClaimsComponent } from '../no-claims/no-claims.component';
import { ClaimsAccordianFaqComponent } from '../claims-accordian-faq/claims-accordian-faq.component';
import { ClaimsNeedHelpComponent } from '../claims-need-help/claims-need-help.component';
import { ClaimsReportComponent } from '../claims-report/claims-report.component';
import { ClaimsHomeCarComponent } from '../claims-dashboard-car/claims-home-car.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import { FlagDataService } from '../../../../../_services/data-services/flag-data.service';
import { FlagResponse } from '@models/flag-response';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, ClaimsHomeCarComponent, ClaimsReportComponent, ClaimsNeedHelpComponent, ClaimsAccordianFaqComponent, NoClaimsComponent],
  selector: 'app-claims-home',
  templateUrl: './claims-home.component.html',
})
export class ClaimsHomeComponent implements OnInit {
  claims: any;
  claimsObject: boolean;
  loading: boolean;
  isAvailable: boolean;
  isAcmic: boolean;
  isMA: boolean;

  constructor(
    private claimsDataService: ClaimsDataService,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private companyTypeService: CompanyTypeService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.isAcmic = this.acmicService.isACMIC();
    const company_list = [];

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      if (response) {
        this.isAvailable = response.cc;
      }
    });

    this.claimsDataService.$claimsLossDetails.subscribe((claimsLossDetails) => {
      if (claimsLossDetails === null) return; // skip initial BehaviorSubject emission

      if (Array.isArray(claimsLossDetails)) {
        this.claims = claimsLossDetails.filter(
          (claim) => claim.number.number !== ''
        );

        claimsLossDetails.forEach((claim) => {
          company_list.push(this.companyTypeService.getCompany(claim.policyNumber.policyNumber));
        });

        if (company_list.includes('MAPFRE') || company_list.includes('AS400')) {
          this.isMA = true;
        }
      }

      this.loading = false;
    });
  }
}
